import { CustomFacet, CustomFacetValue, RangeFacet } from '@catalog/const';
import { ActiveFacet } from '@search/const';

export function mapFacetToActive(facet: CustomFacet | RangeFacet, value: CustomFacetValue): ActiveFacet {
  return {
    contentType: facet.contentType,
    name: facet.name,
    code: facet.code,
    value: {
      code: value.code,
      name: value.name,
    },
  };
}
